package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.repository.WorkplaceRepository

// domain/usecase/skeleton/UpdateWeeklySkeletonUseCase.kt
class UpdateWeeklySkeletonUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(
        workplaceId: String,
        dayIso: Int,
        dayTemplateId: String? // null = clear assignment
    ): Result<Unit> {
        return try {
            // 1. Fetch current (to ensure we don't overwrite other days blindly if we didn't have realtime sync)
            val workplace = workplaceRepository.getWorkplace(workplaceId).getOrThrow()

            // 2. Modify
            val currentSkeleton = workplace.settings.defaultWeeklySkeleton.toMutableMap()
            if (dayTemplateId == null) {
                currentSkeleton.remove(dayIso)
            } else {
                currentSkeleton[dayIso] = dayTemplateId
            }

            // 3. Save
            workplaceRepository.updateWeeklySkeleton(workplaceId, currentSkeleton)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}